import MonthEstimateScreen from "../components/MonthEstimate/MonthEstimateScreen";

export default function MonthEstimatePage() {
  return <MonthEstimateScreen />;
}
